module.exports = __webpack_public_path__ + "img/zendesk.efb261c3.jpg";